<template>
  <v-card flat id="first">
    <v-card-title class="px-1 mx-md-3 pb-0">
      <b-btn
        size="sm"
        :variant="!isCompleted && !isNotCompleted && !isIncomplete ? 'primary' : ''"
        class="mx-0 px-1 p-sm-2 odevlerim"
        @click="
          isCompleted = false
          isNotCompleted = false
          isIncomplete = false
          getHomeworksFromApi()
          screenLevel = 1
        "
        >Ödevlerim
      </b-btn>
      <b-btn
        size="sm"
        class="mx-1 mx-sm-2 px-1 p-sm-2 yaptiklarim"
        :variant="isCompleted && !isNotCompleted ? 'primary' : ''"
        @click="
          isCompleted = true
          isNotCompleted = false
          isIncomplete = false
          getHomeworksFromApi()
          screenLevel = 1
        "
        >Yaptıklarım
      </b-btn>
      <b-btn
        size="sm"
        class="mx-0 px-1 p-sm-2 yapmadiklarim"
        :variant="!isCompleted && isNotCompleted ? 'primary' : ''"
        @click="
          isCompleted = false
          isNotCompleted = true
          isIncomplete = false
          getHomeworksFromApi()
          screenLevel = 1
        "
        >Yapmadıklarım
      </b-btn>
      <b-btn
        size="sm"
        class="mx-1 mx-sm-2 px-1 p-sm-2"
        :variant="isIncomplete ? 'primary' : ''"
        @click="
          isCompleted = false
          isNotCompleted = false
          isIncomplete = true
          getHomeworksFromApi()
          screenLevel = 1
        "
        >Eksik Yaptıklarım
      </b-btn>
      <v-dialog
        ref="dialog"
        v-model="dateDialog"
        :return-value.sync="/* eslint-disable vue/no-mutating-props */ dates"
        persistent
        width="290px"
      >
        <v-card>
          <v-date-picker
            v-model="/* eslint-disable vue/no-mutating-props */ dates"
            scrollable
            range
            color="green lighten-1"
            header-color="primary"
            locale="tr"
            min="2021-09-13"
            first-day-of-week="1"
          >
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="dateDialog = false"> İPTAL</v-btn>
            <v-btn
              text
              color="primary"
              @click="
                getHomeworksFromApi()
                $refs.dialog.save(dates)
              "
            >
              ARA
            </v-btn>
          </v-date-picker>
          <v-radio-group class="mx-3" v-model="orderByCreatedDate">
            <v-radio label="Son Kontrol Tarihine Göre" :value="false"></v-radio>
            <v-radio label="Ödev Yapma Tarihine Göre" :value="true"></v-radio>
          </v-radio-group>
        </v-card>
      </v-dialog>
    </v-card-title>
    <v-progress-linear
      :active="loading"
      :indeterminate="loading"
      color="primary"
      class="mb-0"
    ></v-progress-linear>
    <v-card-text>
      <div v-if="$route.name == 'odevlerim' && (screenLevel == 1 || screenLevel == 2)">
        <div class="d-flex justify-content-around w-100 mb-2">
          <v-btn small icon class="" @click="previousWeek">
            <v-icon left> mdi-chevron-left</v-icon>
            ÖNCEKİ
          </v-btn>
          <v-toolbar-title>
            <div class="d-flex justify-center align-center">
              {{ dates[0] | momentDate }} - {{ dates[1] | momentDate }}
              <v-btn class="float-right ml-1 takvim" icon small @click="dateDialog = true">
                <v-icon> mdi-calendar</v-icon>
              </v-btn>
            </div>
          </v-toolbar-title>
          <v-btn small icon class="" @click="nextWeek">
            SONRAKİ
            <v-icon right> mdi-chevron-right</v-icon>
          </v-btn>
        </div>
      </div>

      <div v-if="screenLevel == 1">
        <div class="table-responsive d-none d-sm-block">
          <table class="table table-hover table-vertical-center mt-2">
            <thead>
              <tr class="text-center">
                <th class="text-start" scope="col">Ders</th>
                <th scope="col">En Yakın Teslim Tarihi</th>
                <th scope="col">Ödev Sayısı</th>
                <th scope="col">Yapılan</th>
                <th scope="col">Yapılmayan</th>
                <th scope="col">Eksik Yapılan</th>
                <th scope="col">Ayrıntı</th>
              </tr>
            </thead>
            <tbody>
              <tr class="text-center" v-if="loading">
                <td colspan="7">
                  <b-spinner variant="primary" label="Spinning"></b-spinner>
                </td>
              </tr>
              <template v-else v-for="(element, index) in homeworksByLesson">
                <tr class="text-center" v-bind:key="index">
                  <td class="text-start" style="max-width: 130px">
                    <span>{{ element.key }}<br /> </span>
                  </td>
                  <td>
                    <v-chip 
                      x-small
                      label
                      :color="getDeadlineColor(element.nearestDeadline, isCompleted)"
                      text-color="white"
                      v-if="element.nearestDeadline"
                    >
                      {{ element.nearestDeadline | momentFull }}
                    </v-chip>
                    <span v-else class="text-muted">-</span>
                  </td>
                  <td>
                    {{
                      element.unAnsweredManualHomeworkCount +
                      element.answeredManualHomeworkCount +
                      element.incompleteManualHomeworkCount
                    }}
                  </td>
                  <td>
                    <b-badge variant="success" v-if="element.answeredManualHomeworkCount > 0">
                      {{ element.answeredManualHomeworkCount }}
                    </b-badge>
                    <span v-else class="text-muted">0</span>
                  </td>
                  <td>
                    <b-badge variant="danger" v-if="element.unAnsweredManualHomeworkCount > 0">
                      {{ element.unAnsweredManualHomeworkCount }}
                    </b-badge>
                    <span v-else class="text-muted">0</span>
                  </td>
                  <td>
                    <b-badge variant="warning" v-if="element.incompleteManualHomeworkCount > 0">
                      {{ element.incompleteManualHomeworkCount }}
                    </b-badge>
                    <span v-else class="text-muted">0</span>
                  </td>
                  <td>
                    <b-button
                      size="sm"
                      variant="outline-primary"
                      v-b-tooltip.hover.left="'Ödevin Ayrıntısı'"
                      :id="'buttonLesson' + index"
                      @click="
                        screenLevel = 2
                        screenLevel2Key = index
                      "
                    >
                      <i class="ki ki-long-arrow-next icon-nm m-0 p-0"></i>
                    </b-button>
                  </td>
                </tr>
              </template>
              <tr class="text-center">
                <td class="text-start"><strong>TOPLAM</strong></td>
                <td></td>
                <td>
                  <strong>
                    {{
                      homeworkByLessonSum.answeredManualHomeworkCount +
                      homeworkByLessonSum.unAnsweredManualHomeworkCount +
                      homeworkByLessonSum.incompleteManualHomeworkCount
                    }}
                  </strong>
                </td>
                <td>
                  <strong>{{ homeworkByLessonSum.answeredManualHomeworkCount }}</strong>
                </td>
                <td>
                  <strong>{{ homeworkByLessonSum.unAnsweredManualHomeworkCount }}</strong>
                </td>
                <td>
                  <strong>{{ homeworkByLessonSum.incompleteManualHomeworkCount }}</strong>
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          v-for="(element, index) in homeworksByLesson"
          :key="element.key"
          class="d-sm-none mb-3"
        >
          <div class="border rounded p-3">
            <div class="d-flex justify-content-between align-items-start mb-1">
              <div>
                <p class="text-dark-75 font-weight-bolder font-size-lg mb-1">
                  {{ element.key }}
                </p>
                <v-chip 
                  x-small
                  :color="getDeadlineColor(element.nearestDeadline, isCompleted)"
                  text-color="white"
                  v-if="element.nearestDeadline"
                  class="mb-1"
                  label
                >
                  <b-icon icon="calendar-event" aria-hidden="true" class="mr-1" font-scale="0.8"></b-icon>
                  {{ element.nearestDeadline | momentFull }}
                </v-chip>
              </div>
              <b-button
                size="sm"
                variant="outline-primary"
                v-b-tooltip.hover.left="'Ödevin Ayrıntısı'"
                :id="'buttonLesson' + index"
                @click="
                  screenLevel = 2
                  screenLevel2Key = index
                "
              >
                <i class="ki ki-long-arrow-next icon-nm m-0 p-0"></i>
              </b-button>
            </div>
            
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex flex-wrap">
                <b-badge 
                  v-if="element.answeredManualHomeworkCount > 0"
                  variant="success" 
                  pill
                  class="mr-1 mb-1"
                >
                  ✓ {{ element.answeredManualHomeworkCount }} Yapılan
                </b-badge>
                <b-badge 
                  v-if="element.unAnsweredManualHomeworkCount > 0"
                  variant="danger" 
                  pill
                  class="mr-1 mb-1"
                >
                  ✗ {{ element.unAnsweredManualHomeworkCount }} Yapılmayan
                </b-badge>
                <b-badge 
                  v-if="element.incompleteManualHomeworkCount > 0"
                  variant="warning" 
                  pill
                  class="mr-1 mb-1"
                >
                  ⚠ {{ element.incompleteManualHomeworkCount }} Eksik
                </b-badge>
              </div>
            </div>
          </div>
        </div>

        <div class="d-sm-none mb-3" v-if="homeworksByLesson.length > 0">
          <div class="border rounded p-3 bg-light">
            <p class="text-dark-75 font-weight-bolder font-size-lg mb-2">TOPLAM</p>
            <div class="d-flex flex-wrap">
              <b-badge 
                v-if="homeworkByLessonSum.answeredManualHomeworkCount > 0"
                variant="success" 
                pill
                class="mr-1 mb-1"
              >
                ✓ {{ homeworkByLessonSum.answeredManualHomeworkCount }} Yapılan
              </b-badge>
              <b-badge 
                v-if="homeworkByLessonSum.unAnsweredManualHomeworkCount > 0"
                variant="danger" 
                pill
                class="mr-1 mb-1"
              >
                ✗ {{ homeworkByLessonSum.unAnsweredManualHomeworkCount }} Yapılmayan
              </b-badge>
              <b-badge 
                v-if="homeworkByLessonSum.incompleteManualHomeworkCount > 0"
                variant="warning" 
                pill
                class="mr-1 mb-1"
              >
                ⚠ {{ homeworkByLessonSum.incompleteManualHomeworkCount }} Eksik
              </b-badge>
            </div>
          </div>
        </div>
      </div>
      <div v-if="screenLevel == 2">
        <div class="row my-2 mx-sm-2">
          <b-button
            size="sm"
            class="mx-3 mt-0 geri"
            id="geri"
            variant="outline-primary"
            @click="
              screenLevel = 1
              screenLevel2Key = null
            "
          >
            <b-icon icon="arrow90deg-left"></b-icon>
          </b-button>
          <h3 class="mt-1">{{ homeworksByLesson[screenLevel2Key].key }}</h3>
        </div>
        <div
          class="row mt-4 m-sm-5"
          :class="
            homeworksByLesson[screenLevel2Key].values.length > 1
              ? 'border border-primary rounded'
              : ''
          "
          v-for="(item, i) in homeworksByLesson[screenLevel2Key].values"
          :key="item.key"
        >
          <div class="col-12 m-0 p-0">
            <b-collapse visible :id="'innercollapse-' + screenLevel2Key + '-' + i" class="row m-1">
              <div
                v-for="(thing, idx) in item.values"
                :key="idx"
                class="col-sm-6 col-md-4 mb-3"
                :class="'test-' + idx"
              >
                <div 
                  class="border rounded p-3 h-100 position-relative" 
                  style="cursor: pointer;" 
                  @click="goToDocumentAnswer(thing.HomeworkId)"
                  :class="{
                    'border-success': thing.IsManualHomeworkAnswered && !thing.IsIncomplete,
                    'border-danger': !thing.IsManualHomeworkAnswered && !thing.IsIncomplete,
                    'border-warning': thing.IsIncomplete
                  }"
                >
                  <div class="position-absolute" style="top: 8px; right: 8px;">
                    <b-badge 
                      v-if="thing.IsManualHomeworkAnswered && !thing.IsIncomplete"
                      variant="success"
                      pill
                    >
                      <b-icon icon="check-circle-fill" aria-hidden="true"></b-icon>
                    </b-badge>
                    <b-badge 
                      v-else-if="thing.IsIncomplete"
                      variant="warning"
                      pill
                    >
                      <b-icon icon="exclamation-triangle-fill" aria-hidden="true"></b-icon>
                    </b-badge>
                    <b-badge 
                      v-else
                      variant="danger"
                      pill
                    >
                      <b-icon icon="x-circle-fill" aria-hidden="true"></b-icon>
                    </b-badge>
                  </div>
                  
                  <div class="d-flex flex-column">
                    <div class="mb-2 pr-4">
                      <b-icon icon="file-earmark-check" aria-hidden="true" class="mr-1"></b-icon>
                      <span class="text-gray-800 fw-bolder">{{ thing.HomeworkName }}</span>
                    </div>
                    <div class="mb-2">
                      <small class="text-muted">
                        <b-icon icon="book" aria-hidden="true" class="mr-1"></b-icon>
                        {{ thing.LessonName }}
                      </small>
                    </div>
                    <div class="mb-2">
                      <v-chip 
                        x-small
                        :color="getDeadlineColor(thing.EndDate, thing.IsManualHomeworkAnswered && !thing.IsIncomplete)"
                        text-color="white"
                        label
                      >
                        <b-icon icon="calendar-event" aria-hidden="true" class="mr-1" font-scale="0.8"></b-icon>
                        {{ thing.EndDate | momentFull }}
                      </v-chip>
                    </div>
                    <div>
                      <b-badge 
                        v-if="thing.IsManualHomeworkAnswered && !thing.IsIncomplete"
                        variant="success"
                        class="mt-1"
                      >
                        ✓ Yapıldı
                      </b-badge>
                      <b-badge 
                        v-else-if="thing.IsIncomplete"
                        variant="warning"
                        class="mt-1"
                      >
                        ⚠ Eksik Yapıldı
                      </b-badge>
                      <b-badge 
                        v-else
                        variant="danger"
                        class="mt-1"
                      >
                        ✗ Yapılmadı
                      </b-badge>
                    </div>
                  </div>
                </div>
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
      <div v-if="screenLevel == 3">
        <ManualHomeworkAnswersWidget
          :homework="editedItem"
          :homeworkId="screenLevel3HomeworkId"
          v-model="screenLevel"
          :isStrict="editedItem.IsStrict"
          :endDate="editedItem.EndDate"
        />
      </div>
      <div v-if="homeworksByLesson.length == 0" class="text-center">
        {{ dates[0] | moment }} - <span v-if="dates[1]"> {{ dates[1] | moment }}</span>
        <span v-else>∞</span>
        Tarihlerinde ödeviniz bulunmamaktadır.
        <p>Üstte bulunan takvim ikonuna tıklayarak tarih filtresini kullanabilirsiniz.</p>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
/* eslint-disable vue/no-mutating-props */

import ApiService from '@/core/services/api.service.js'
import moment from 'moment'
import ManualHomeworkAnswersWidget from '@/view/pages/dashboard_widgets/ManualHomeworkAnswersWidget.vue'

export default {
  props: ['dates'],
  data() {
    return {
      loading: false,
      loadingAnswer: false,
      homeworks: [],
      isCompleted: false,
      dateDialog: false,
      tab: null,
      homeworksByLesson: [],
      isNotCompleted: false,
      isIncomplete: false,
      screenLevel: 1,
      screenLevel2Key: null,
      innercollapseOpenedKey: null,
      screenLevel3SourceTestId: null,
      screenLevel3HomeworkId: null,
      scrollOptions: { duration: 500, offset: 0, easing: 'easeInOutCubic' },
      homeworkByLessonSum: {},
      editedItem: {},
      sourceTestResult: {},
      orderByCreatedDate: false
    }
  },
  components: { ManualHomeworkAnswersWidget },
  watch: {
    screenLevel(newValue, oldValue) {
      if (newValue === 2 && oldValue === 3) {
        if (
          (this.sourceTestResult.CorrectCount > 0 || this.sourceTestResult.WrongCount > 0) &&
          this.homeworks.length > 0
        ) {
          Object.assign(
            this.homeworks.find((s) => s.HomeworkId === this.sourceTestResult.HomeworkId)
              .SourceTestResult,
            this.sourceTestResult
          )
        }
        this.homeworkSync()
        this.editedItem = {}
      }
      // this.$vuetify.goTo('#first', this.scrollOptions)
    }
  },
  filters: {
    moment: function (date) {
      return date ? moment(date).locale('tr').format('Do MMMM dddd') : ''
    },
    momentDate: function (date) {
      return date ? moment(date).locale('tr').format('Do MMMM') : ''
    },
    momentFull: function (date) {
      return date ? moment(date).locale('tr').format('DD.MM.YYYY HH:mm') : ''
    }
  },
  mounted() {
    this.getHomeworksFromApi()
  },
  methods: {
    moment: function () {
      return moment()
    },
    getHomeworksFromApi() {
      this.loading = true
      if (this.dates[0] && this.dates[1] && this.$route.name == 'odevlerim') {
        var g1 = new Date(this.dates[0])
        var g2 = new Date(this.dates[1])
        if (g2.getTime() < g1.getTime()) {
          var tmpDate = this.dates[0]
          this.dates[0] = this.dates[1]
          this.dates[1] = tmpDate
        }
      }
      var model = {
        StartDate: this.dates[0],
        EndDate: this.dates[1],
        IsCompleted: this.isCompleted,
        IsNotCompleted: this.isNotCompleted,
        IsIncomplete: this.isIncomplete,
        OrderByCreatedDate: this.orderByCreatedDate
      }
      ApiService.setHeader()
      ApiService.post('api/Homework/ManualHomeworkStudent', model)
        .then((data) => {
          this.loading = false
          this.homeworks = data.data
          this.homeworkSync()
        })
        .catch(({ response }) => {
          ApiService.showError(response)
          this.loading = false
        })
    },
    homeworkSync() {
      this.homeworksByLesson = this.groupByArray(this.homeworks, 'LessonName')

      var values = this.homeworksByLesson.map((s) => {
        return s.values
      })
      this.homeworkByLessonSum = {
        answeredManualHomeworkCount: 0,
        unAnsweredManualHomeworkCount: 0,
        incompleteManualHomeworkCount: 0
      }
      for (let index = 0; index < values.length; index++) {
        const element = values[index]
        this.homeworksByLesson[index].values = this.groupByArray(element, 'SourceName')
        var endDate = null
        var nearestDeadline = null
        var answeredManualHomeworkCount = 0
        var unAnsweredManualHomeworkCount = 0
        var incompleteManualHomeworkCount = 0

        for (let i = 0; i < element.length; i++) {
          if (element[i].IsIncomplete) {
            incompleteManualHomeworkCount += 1
          } else {
            if (element[i].IsManualHomeworkAnswered) {
              answeredManualHomeworkCount += 1
            } else {
              unAnsweredManualHomeworkCount += 1
            }
          }

          // En yakın teslim tarihini bul (sadece yapılmayan ve eksik ödevler için)
          if (element[i].EndDate && (!element[i].IsManualHomeworkAnswered || element[i].IsIncomplete)) {
            if (!nearestDeadline || moment(element[i].EndDate).isBefore(moment(nearestDeadline))) {
              nearestDeadline = element[i].EndDate
            }
          }

          this.homeworksByLesson[index].answeredManualHomeworkCount = answeredManualHomeworkCount
          this.homeworksByLesson[index].incompleteManualHomeworkCount =
            incompleteManualHomeworkCount
          this.homeworksByLesson[index].unAnsweredManualHomeworkCount =
            unAnsweredManualHomeworkCount

          endDate = element[i].EndDate
        }

        this.homeworksByLesson[index].endDate = endDate
        this.homeworksByLesson[index].nearestDeadline = nearestDeadline
        this.homeworkByLessonSum.answeredManualHomeworkCount += answeredManualHomeworkCount
        this.homeworkByLessonSum.unAnsweredManualHomeworkCount += unAnsweredManualHomeworkCount
        this.homeworkByLessonSum.incompleteManualHomeworkCount += incompleteManualHomeworkCount

        for (let j = 0; j < this.homeworksByLesson[index].values.length; j++) {
          const test = this.homeworksByLesson[index].values[j]
          endDate = null
          for (let i = 0; i < test.values.length; i++) {
            endDate = test.values[i].EndDate
          }

          this.homeworksByLesson[index].values[j].endDate = endDate
        }
      }
    },
    groupByArray(xs, key) {
      return xs.reduce(function (rv, x) {
        let v = key instanceof Function ? key(x) : x[key]
        let el = rv.find((r) => r && r.key === v)
        if (el) {
          el.values.push(x)
        } else {
          rv.push({ key: v, values: [x] })
        }
        return rv
      }, [])
    },

    goToDocumentAnswer(homeworkId) {
      this.editedItem = this.homeworks.find((x) => x.HomeworkId == homeworkId)
      this.screenLevel3HomeworkId = homeworkId
      this.screenLevel3SourceTestId = 0
      this.screenLevel = 3
    },
    previousWeek() {
      // başlangıç tarihine göre haftanın pazartesi gününü bul
      var d = new Date(this.dates[0])
      d = this.getMonday(d.isValid() ? d : new Date())

      d = d.addDays(-7)
      this.dates[0] = d.toISOString().slice(0, 10)
      //pazar gününü bul

      this.dates[1] = d.addDays(6).toISOString().slice(0, 10)
      this.getHomeworksFromApi()
    },
    nextWeek() {
      // başlangıç tarihine göre haftanın pazartesi gününü bul
      var d = new Date(this.dates[0])
      d = this.getMonday(d.isValid() ? d : new Date())

      d = d.addDays(7)
      this.dates[0] = d.toISOString().slice(0, 10)
      //pazar gününü bul
      this.dates[1] = d.addDays(6).toISOString().slice(0, 10)

      this.getHomeworksFromApi()
    },
    getMonday(d) {
      d = new Date(d)
      var day = d.getDay(),
        diff = d.getDate() - day + (day == 0 ? -6 : 1) // adjust when day is sunday
      return new Date(d.setDate(diff))
    },
    getDeadlineColor(endDate, isCompleted) {
      if (!endDate) return 'grey'
      
      // Yapılmış ödevler için mavi renk
      if (isCompleted) {
        return 'blue'
      }
      
      const now = moment()
      const deadline = moment(endDate)
      const hoursUntilDeadline = deadline.diff(now, 'hours')
      
      if (hoursUntilDeadline < 0) {
        // Süresi geçmiş - Kırmızı
        return 'red'
      } else if (hoursUntilDeadline < 24) {
        // 24 saatten az kaldı - Turuncu
        return 'orange'
      } else if (hoursUntilDeadline < 72) {
        // 3 günden az kaldı - Sarı
        return 'amber'
      } else {
        // Normal - Yeşil
        return 'green'
      }
    }
  }
}
</script>
